import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import BreadCrumbsBar from "../components/breadCrumbsBar";
import AboutUs from "../components/aboutUs";
function WhyPage() {
  return (
    <div>
      <Header />
      <BreadCrumbsBar />
      <AboutUs />
      <Footer />
    </div>
  );
}

export default WhyPage;
